import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastService } from '@core';

@Component({
    selector: 'ups-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ToastComponent {
  public toastMessage$: Observable<{
    message?: string;
    variant: 'error' | 'info' | 'success' | 'warning';
    translate: boolean;
    duration: number;
  }>;

  constructor(private readonly toastService: ToastService) {
    this.toastMessage$ = this.toastService.toastMessage$;
  }
}
